module.exports = __webpack_public_path__ + "img/project_max_grey_border.2bdbde24.svg";